import { useEffect, useState } from 'react';
import {
  _loadTriviaHistory,
  _computeStreak,
  _bestScore,
} from '../utils/triviaHelpers';
import { _loadUserStatsCache } from '../utils/userStatsCache';

const useTriviaLocalStats = ({ resolvedUid, setUserStats }) => {
  const [history, setHistory] = useState(() => _loadTriviaHistory(resolvedUid));
  const [streak, setStreak] = useState(() => _computeStreak(_loadTriviaHistory(resolvedUid)));
  const [best, setBest] = useState(() => _bestScore(_loadTriviaHistory(resolvedUid)));

  useEffect(() => {
    const h = _loadTriviaHistory(resolvedUid);
    setHistory(h);
    setStreak(_computeStreak(h));
    setBest(_bestScore(h));
    setUserStats(_loadUserStatsCache(resolvedUid));
  }, [resolvedUid, setUserStats]);

  return {
    history,
    setHistory,
    streak,
    setStreak,
    best,
    setBest,
  };
};

export default useTriviaLocalStats;
